import useSWR from 'swr';
import { API_HOST } from '../helpers/constants';
import { fetcher } from '../utils';

export function useLeadReason(id) {
  const url = `${API_HOST}/lead-reasons/${id}`;

  const { data: responseData, error, isLoading, mutate } = useSWR(id ? url : null, fetcher);

  const revalidate = () => mutate(url);

  return {
    leadReason: responseData,
    isLoading,
    isError: error,
    revalidate
  };
}
